import { Box, Text, Spinner, Center } from "@chakra-ui/react";
import MyDiv from "./departmentJobOpening.style";
import { BarChart, Bar, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList,} from "recharts";

interface DepartmentJobOpeningProps {
  data: any[];
  loading: boolean;
}

const DepartmentJobOpening = ({ data, loading }: DepartmentJobOpeningProps) => {
  const hasData = Array.isArray(data) && data.length > 0;

  return (
    <MyDiv>
      <Box className="card_box" p={4}>
        <Text mb={4} className="font-poppins text_xl text_medium">Department-wise Job Openings</Text>
        
        {loading ? (
          <Center h="300px">
            <Spinner size="lg" color="blue.500" />
          </Center>
        ) : hasData ? (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data} className="font-poppins text_xsm text_medium">
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="departmentName" className="font-poppins text_xsm text_medium" />
              <Tooltip />
              <Bar dataKey="totalOpenings" fill="#344BFD" radius={[8, 8, 0, 0]}>
                <LabelList dataKey="totalOpenings" position="top" />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Center h="300px">
            <Text className="font-poppins text_md text_medium" color="gray.500">No Data Available</Text>
          </Center>
        )}
      </Box>
    </MyDiv>
  );
};

export default DepartmentJobOpening;
